import {Types} from 'mongoose';

export const COURT_DEPARTMENTS = {
    type: 'Court Departments',
    category: 'System',
    value: [
        {
            _id: new Types.ObjectId('507f1f77bcf86cd799439132'),
            label: 'Boston Municipal',
            description:
                'MA trial court that serves Suffolk County, specifically the City of Boston and the Town of Winthrop',
            types: [
                {
                    label: 'Civil [CV]',
                    _id: new Types.ObjectId('507f1f77bcf86cd799439032'),
                },
                {
                    label: 'Criminal [AC]',
                    _id: new Types.ObjectId('507f1f77bcf86cd799439033'),
                },
                {
                    label: 'Harassment Prevent Order (HPO) [RO]',
                    _id: new Types.ObjectId('507f1f77bcf86cd799439034'),
                },
                {
                    label: 'Small Claims [SC]',
                    _id: new Types.ObjectId('507f1f77bcf86cd799439035'),
                },
                {
                    label: 'Summary Process [SU]',
                    _id: new Types.ObjectId('507f1f77bcf86cd799439036'),
                },
                {
                    label: 'Supplementary Process [SP]',
                    _id: new Types.ObjectId('507f1f77bcf86cd799439037'),
                },
                {label: 'Other', _id: new Types.ObjectId('507f1f77bcf86cd799439038')},
            ].map(d => ({...d, active: true})),
        },
        {
            _id: new Types.ObjectId('507f1f77bcf86cd799439232'),
            label: 'District',
            description: 'MA trial court of limited jurisdiction, with 61 divisions',
            types: [
                {
                    label: 'Civil [CV]',
                    _id: new Types.ObjectId('507f1f77bcf86cd799439039'),
                },
                {
                    label: 'Criminal [AC]',
                    _id: new Types.ObjectId('507f1f77bcf86cd799439040'),
                },
                {
                    label: 'Harassment Prevent Order (HPO) [RO]',
                    _id: new Types.ObjectId('507f1f77bcf86cd799439041'),
                },
                {
                    label: 'Small Claims [SC]',
                    _id: new Types.ObjectId('507f1f77bcf86cd799439042'),
                },
                {
                    label: 'Summary Process [SU]',
                    _id: new Types.ObjectId('507f1f77bcf86cd799439043'),
                },
                {
                    label: 'Supplementary Process [SP]',
                    _id: new Types.ObjectId('507f1f77bcf86cd799439044'),
                },
                {label: 'Other', _id: new Types.ObjectId('507f1f77bcf86cd799439045')},
            ].map(d => ({...d, active: true})),
        },
        {
            _id: new Types.ObjectId('507f1f77bcf86cd799439332'),
            label: 'Housing',
            description: 'MA trial court, with six divisions, that handles matters involving residential housing',
            types: [{label: 'Other', _id: new Types.ObjectId('507f1f77bcf86cd799439046')}].map(d => ({
                ...d,
                active: true,
            })),
        },
        {
            _id: new Types.ObjectId('507f1f77bcf86cd799439432'),
            label: 'Juvenile',
            description: 'MA trial court with general jurisdiction over matters involving children',
            types: [
                {
                    label: 'Assault Charge [AC]',
                    _id: new Types.ObjectId('507f1f77bcf86cd799439047'),
                },
                {
                    label: 'Care and Protection (C&P) [CP]',
                    _id: new Types.ObjectId('507f1f77bcf86cd799439048'),
                },
                {
                    label: 'Child Requiring Assistance (CRA) [CRA]',
                    _id: new Types.ObjectId('507f1f77bcf86cd799439049'),
                },
                {
                    label: 'Delinquency [DL]',
                    _id: new Types.ObjectId('507f1f77bcf86cd799439050'),
                },
                {
                    label: 'Guardianship [GU]',
                    _id: new Types.ObjectId('507f1f77bcf86cd799439051'),
                },
                {
                    label: 'Harassment Prevention Order (HPO) [HA]',
                    _id: new Types.ObjectId('507f1f77bcf86cd799439052'),
                },
                {label: 'Other', _id: new Types.ObjectId('507f1f77bcf86cd799439053')},
            ].map(d => ({...d, active: true})),
        },
        {
            _id: new Types.ObjectId('507f1f77bcf86cd798439432'),
            label: 'Land',
            description: 'MA trial court with limited subject matter jurisdiction over real property',
            types: [{label: 'Other', _id: new Types.ObjectId('507f1f77bcf86cd799439054')}].map(d => ({
                ...d,
                active: true,
            })),
        },
        {
            _id: new Types.ObjectId('507f4f77bcf86cd799439532'),
            label: 'Probate and Family',
            description:
                'MA trial court with limited subject matter jurisdiction over family-related matters and probate matters',
            types: [
                // {
                //     label: 'Alt Div',
                //     _id: new Types.ObjectId('507f1f77bcf86cd799439055'),
                // },
                // {
                //     label: 'Post Div',
                //     _id: new Types.ObjectId('507f1f77bcf86cd799479056'),
                // },
                {
                    label: 'Divorce',
                    _id: new Types.ObjectId('507f1f77bcf86cd799439058'),
                },
                // {
                //     label: 'Post Divorce',
                //     _id: new Types.ObjectId('507f1f77bcf86cd799439158'),
                // },
                {
                    label: 'Custody',
                    _id: new Types.ObjectId('507f1f77bcf86cd799439056'),
                },
                // {
                //     label: 'Domestic Violence',
                //     _id: new Types.ObjectId('507f1f77bcf86cd799439057'),
                // },
                {label: 'Elder', _id: new Types.ObjectId('507f1f77bcf86cd799439059')},
                {
                    label: 'Estate/Business/Finance',
                    _id: new Types.ObjectId('507f1f77bcf86cd799439060'),
                },
                {
                    label: 'Grandparents',
                    _id: new Types.ObjectId('507f1f77bcf86cd799439061'),
                },
                {
                    label: 'Parent/Child',
                    _id: new Types.ObjectId('507f1f77bcf86cd799439062'),
                },
                {
                    label: 'Parenting Plan',
                    _id: new Types.ObjectId('507f1f77bcf86cd799439063'),
                },
                {
                    label: 'Paternity',
                    _id: new Types.ObjectId('507f1f77bcf86cd799439064'),
                },
                {
                    label: 'Permancy/Adoption',
                    _id: new Types.ObjectId('507f1f77bcf86cd799439065'),
                },
                {
                    label: 'Separation',
                    _id: new Types.ObjectId('507f1f77bcf86cd799439066'),
                },
                {label: 'Other', _id: new Types.ObjectId('507f1f77bcf86cd799439067')},
            ].map(d => ({...d, active: true})),
        },
        {
            _id: new Types.ObjectId('507f1f77bcf86cd799439532'),
            label: 'Superior',
            description: 'MA trial court of general jurisdiction',
            types: [{label: 'Other', _id: new Types.ObjectId('507f1f77bcf86cd799439068')}].map(d => ({
                ...d,
                active: true,
            })),
        },
    ].map(d => ({...d, active: true})),
};
